var map = {
	"./Pin-Dark-Delegacia.svg": 641,
	"./Pin-Dark-Moto.svg": 642,
	"./Pin-Dark-Ocorrencia.svg": 643,
	"./Pin-Dark-Policial.svg": 644,
	"./Pin-Dark-Viatura.svg": 645,
	"./Pin-Light-Delegacia.svg": 646,
	"./Pin-Light-Moto.svg": 647,
	"./Pin-Light-Ocorrencia.svg": 648,
	"./Pin-Light-Policial.svg": 649,
	"./Pin-Light-Viatura.svg": 650
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1161;